module.exports = __webpack_public_path__ + "media/images/top/idea-item01-cfb559a5d30fcc49f3aebb721060a37c.webp";